import { useDispatch, useSelector } from "react-redux";
 
import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect } from "react";
import {
  getAdminSettings,
  getToBeUpdatedAdminSettingsData,
} from "../../features/adminSett/adminSettSlice";
import AnimatedToggle from "../../components/shared/customInput/AnimatedToggle";
import { useState } from "react";
import Button from "../../components/shared/Button";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import { showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;
      display: flex;
      justify-content: center;

      .side-container {
        width: 90%;
        display: flex;
        justify-content: space-between;
        gap: 100px;
        @media (max-width: 1550px) {
          height: auto;
        }

        .side {
          width: calc(50% - 50px);
          display: flex;
          flex-direction: column;

          .side-top {
            display: flex;
            align-items: center;
            background-color: var(--color-main);
            padding: 12px;
            border-radius: 10px;
            margin-bottom: 10px;

            h3 {
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-xl);
              color: ${({ theme }) => theme.reverseMainTextColor};
            }
          }

          .settings-list {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 8px;
            @media (max-width: 1550px) {
              height: 100%;
              justify-content: space-between;
            }

            .settings-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 5px;
              height: 50px;
              border-radius: 10px;
              border: 1px solid transparent;

              &:hover {
                border-color: ${({ theme }) => theme.mainBorderColor};
              }

              .key {
                color: ${({ theme }) => theme.mainTextColor};
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-md);
              }

              .value {
                .input {
                  background-color: transparent;
                  border: 1px solid ${({ theme }) => theme.mainBorderColor};
                  height: 40px;
                  padding: 0 10px;
                  width: 100px;
                  border-radius: 5px;
                  font-size: var(--font-size-md);
                  font-weight: var(--font-weight-md);
                  color: ${({ theme }) => theme.mainTextColor};
                  text-align: center;
                }
              }
            }

            .updated {
              background-color: ${({ theme }) => theme.secondaryBgColor};
            }

            .btn-wrapper {
              width: 100%;
              display: flex;
              justify-content: center;
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
`;

const AdminSettings = () => {

  const { settingsData } = useSelector((state) => state.adminSett);

  const [maliyetHesaplamaBtn, setMaliyetHesaplamaBtn] = useState(null); //!
  const [mobilDuyuru, setMobilDuyuru] = useState(null); //!
  const [anasayfaBaslik, setAnasayfaBaslik] = useState(null);
  const [yukBildirimIrsaliyeMod, setYukBildirimIrsaliyeMod] = useState(null);
  const [yuklerSayfasiFiyatGozuksun, setYuklerSayfasiFiyatGozuksun] =
    useState(null);

  //! api gelince kaldır
  const kdv = "20";
  const nakliyeTevkifat = "20";
  const tevkifatliFatura = "2.000";
  const vergiMukellef = "4.400";
  const vergiMukellefOlmayan = "5.000";
  const yavasGider = "10";
  const hizligider = "10";

  const [kdvOran, setKdvOran] = useState("20");
  const [nakliyeTevkifatOran, setNakliyeTevkifatOran] = useState("20");
  const [tevkifatliFaturaLimit, setTevkifatliFaturaLimit] = useState("2.000");
  const [vergiMukellefEArsivFaturaLimit, setVergiMukellefEArsivFaturaLimit] =
    useState("4.400");
  const [
    vergiMukellefOlmayanEArsivFaturaLimit,
    setVergiMukellefOlmayanEArsivFaturaLimit,
  ] = useState("5.000");
  const [yavasGiderOran, setYavasGiderOran] = useState("10");
  const [hizliGiderOran, setHizliGiderOran] = useState("10");

  //! bu güncelleme yapıldığında ilgili button a hover olunduğunda değiştirilen itemları belli etmek için
  const [hoverGenelSubmitBtn, setHoverGenelSubmitBtn] = useState(false);
  const [hoverMobilSubmitBtn, setHoverMobilSubmitBtn] = useState(false);

  useEffect(() => {
    if (settingsData) {
      setMaliyetHesaplamaBtn(settingsData.yukDetayMaliyetHesapButton);
      setMobilDuyuru(settingsData.mobilAnaSayfaDuyurularMode);
      setAnasayfaBaslik(settingsData.anaSayfaBaslikMode);
      setYukBildirimIrsaliyeMod(settingsData.yukBildirimiMode);
      setYuklerSayfasiFiyatGozuksun(settingsData.loadsPageFreightOnOff);
    }
  }, [settingsData]);

  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(getAdminSettings());
  }, []);

  if (!settingsData) {
    return null;
  }

  const handleSubmit = (type) => {
    const updatedData = {
      ...settingsData,
      anaSayfaBaslikMode: anasayfaBaslik,
      loadsPageFreightOnOff: yuklerSayfasiFiyatGozuksun,
      mobilAnaSayfaDuyurularMode: mobilDuyuru,
      yukBildirimiMode: yukBildirimIrsaliyeMod,
      yukDetayMaliyetHesapButton: maliyetHesaplamaBtn,
    };

    dispatch(getToBeUpdatedAdminSettingsData({ updatedData, type }));
    dispatch(showModal("adminSettingsPermission"));
  };

  const handleChange = (e, setData) => {
    const text = e.target.value;
    // Sadece rakamları içeren bir regular expression kullanarak kontrol ediyoruz
    const onlyNumbers = /^[\d,.]*$/;
    if (onlyNumbers.test(text)) {
      setData(text);
    }
  };

  //! burada herhangi birisi null gelmiyorsa zaten data gelmiştir demek
  if (maliyetHesaplamaBtn === null) {
    return null;
  }

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Uygulama Ayarları"} position="sticky" />
        <div className="content">
          <div className="side-container">
            <div className="side">
              <div className="side-top">
                <h3>Genel Uygulama Ayarları</h3>
              </div>
              <div className="settings-list">
                <div
                  className={
                    kdvOran !== kdv && hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">KDV Oranı? (%)</div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={kdvOran}
                      onChange={(e) => handleChange(e, setKdvOran)}
                    />
                  </div>
                </div>
                <div
                  className={
                    nakliyeTevkifatOran !== nakliyeTevkifat &&
                    hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Nakliye Tevkifat Oranı? (%)</div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={nakliyeTevkifatOran}
                      onChange={(e) => handleChange(e, setNakliyeTevkifatOran)}
                    />
                  </div>
                </div>
                <div
                  className={
                    tevkifatliFaturaLimit !== tevkifatliFatura &&
                    hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Tevkifatlı Fatura Limiti? (TL)</div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={tevkifatliFaturaLimit}
                      onChange={(e) =>
                        handleChange(e, setTevkifatliFaturaLimit)
                      }
                    />
                  </div>
                </div>
                <div
                  className={
                    vergiMukellefEArsivFaturaLimit !== vergiMukellef &&
                    hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">
                    Vergi Mükellefi E-Arşiv Fatura Limiti? (TL)
                  </div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={vergiMukellefEArsivFaturaLimit}
                      onChange={(e) =>
                        handleChange(e, setVergiMukellefEArsivFaturaLimit)
                      }
                    />
                  </div>
                </div>
                <div
                  className={
                    vergiMukellefOlmayanEArsivFaturaLimit !==
                      vergiMukellefOlmayan && hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">
                    Vergi Mükellefi Olmayan E-Arşiv Fatura Limiti? (TL)
                  </div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={vergiMukellefOlmayanEArsivFaturaLimit}
                      onChange={(e) =>
                        handleChange(
                          e,
                          setVergiMukellefOlmayanEArsivFaturaLimit
                        )
                      }
                    />
                  </div>
                </div>
                <div
                  className={
                    yavasGiderOran !== yavasGider && hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Yavaş Gider Düşürülecek Oran? (%)</div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={yavasGiderOran}
                      onChange={(e) => handleChange(e, setYavasGiderOran)}
                    />
                  </div>
                </div>
                <div
                  className={
                    hizliGiderOran !== hizligider && hoverGenelSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Hızlı Gider Düşürülecek Oran? (%)</div>
                  <div className="value">
                    <input
                      type="text"
                      className="input"
                      value={hizliGiderOran}
                      onChange={(e) => handleChange(e, setHizliGiderOran)}
                    />
                  </div>
                </div>
                <div className="btn-wrapper">
                  <Button
                    color={"#F4F4F4"}
                    background={"#0EAC00"}
                    width="220px"
                    radius={"10px"}
                    text={"Güncelle"}
                    padding="0 10px"
                    handleClick={() => handleSubmit("Mobil")}
                    handleMouseEnter={() => setHoverGenelSubmitBtn(true)}
                    handleMouseLeave={() => setHoverGenelSubmitBtn(false)}
                  />
                </div>
              </div>
            </div>
            <div className="side">
              <div className="side-top">
                <h3>Kamyon Mobil Uygulama Ayarları</h3>
              </div>
              <div className="settings-list">
                <div
                  className={
                    settingsData.yukDetayMaliyetHesapButton !==
                      maliyetHesaplamaBtn && hoverMobilSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">
                    Yük detayında maliyet hesaplama butonu gözüksün mü?
                  </div>
                  <div className="value">
                    <AnimatedToggle
                      initial={maliyetHesaplamaBtn}
                      setState={setMaliyetHesaplamaBtn}
                    />
                  </div>
                </div>
                <div
                  className={
                    settingsData.mobilAnaSayfaDuyurularMode !== mobilDuyuru &&
                    hoverMobilSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Mobilde duyurular açık olsun mu?</div>
                  <div className="value">
                    <AnimatedToggle
                      initial={mobilDuyuru}
                      setState={setMobilDuyuru}
                    />
                  </div>
                </div>
                <div
                  className={
                    settingsData.anaSayfaBaslikMode !== anasayfaBaslik &&
                    hoverMobilSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">Anasayfada başlık açık olsun mu?</div>
                  <div className="value">
                    <AnimatedToggle
                      initial={anasayfaBaslik}
                      setState={setAnasayfaBaslik}
                    />
                  </div>
                </div>
                <div
                  className={
                    settingsData.yukBildirimiMode !== yukBildirimIrsaliyeMod &&
                    hoverMobilSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">
                    Yük bildiriminde irsaliye modu açık olsun mu?
                  </div>
                  <div className="value">
                    <AnimatedToggle
                      initial={yukBildirimIrsaliyeMod}
                      setState={setYukBildirimIrsaliyeMod}
                    />
                  </div>
                </div>
                <div
                  className={
                    settingsData.loadsPageFreightOnOff !==
                      yuklerSayfasiFiyatGozuksun && hoverMobilSubmitBtn
                      ? "updated settings-item"
                      : "settings-item"
                  }
                >
                  <div className="key">
                    Yükler sayfasında fiyat görünsün mü?
                  </div>
                  <div className="value">
                    <AnimatedToggle
                      initial={yuklerSayfasiFiyatGozuksun}
                      setState={setYuklerSayfasiFiyatGozuksun}
                    />
                  </div>
                </div>
                <div className="btn-wrapper">
                  <Button
                    color={"#F4F4F4"}
                    background={"#0EAC00"}
                    width="220px"
                    radius={"10px"}
                    text={"Güncelle"}
                    padding="0 10px"
                    handleClick={() => handleSubmit("Mobil")}
                    handleMouseEnter={() => setHoverMobilSubmitBtn(true)}
                    handleMouseLeave={() => setHoverMobilSubmitBtn(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminSettings;
